export default __webpack_public_path__ + "static/media/currency.45ce4ea0.svg";